import React, { FC } from 'react';
import styled from 'styled-components';

import { ClockRowItem } from './ClockListItem';
import { clocksPerRow } from '../../../config';
import App from '../../../models/app';

const Row = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
`;

const RowItem = styled.div`
  width: calc(33% - 22.5px);
  text-align: center;
`;

interface ClockRowProps {
  index: number;
  apps: App[];
  collectionId?: string;
}

export const ClockRow: FC<ClockRowProps> = ({ index, apps, collectionId }) => {
  const appIndex = index * clocksPerRow;
  const clocks = [];
  for (let i = 0; i < clocksPerRow; i++) {
    const clock = apps[appIndex + i];
    clocks.push(
      clock ? (
        <ClockRowItem
          key={clock.id}
          clock={clock}
          selected={clock.isInstalledOrInstalling}
          collectionId={collectionId}
        />
      ) : (
        <RowItem
          key={`list-placeholder-item-${i}`}
        />
      )
    );
  }

  return <Row>{clocks}</Row>;
};
